import { APP_CFG } from '@/configs';
export { cn } from '@/lib/utils';

// Legacy SUI-specific functions - deprecated, use useCurrency hook instead
export function toRoundFixed(value: number): number {
	return Math.round(value * 100) / 100;
}

export function toFloorFixed(value: number): number {
	return Math.floor(value * 100) / 100;
}

export function toFixedRound(amount: number) {
	return Math.round(amount * 100) / 100;
}

export function normalizeCoinType(coinType: string): string {
	if (!coinType) {
		return coinType;
	}

	const parts = coinType.split('::');

	if (parts.length < 3) {
		const rawAddress = coinType.startsWith('0x') ? coinType.slice(2) : coinType;
		const trimmedAddress = rawAddress.replace(/^0+/, '') || '0';
		return `0x${trimmedAddress.toLowerCase()}`;
	}

	const [rawAddress, module, ...rest] = parts;
	const hexAddress = rawAddress.startsWith('0x') ? rawAddress.slice(2) : rawAddress;
	const trimmedAddress = hexAddress.replace(/^0+/, '') || '0';
	const normalizedAddress = `0x${trimmedAddress.toLowerCase()}`;

	return [normalizedAddress, module, ...rest].join('::');
}

export function getExplorerLink(address: string, type: string = 'txblock'): string {
	return `${APP_CFG.SUI_EXPLORER_URL}${type}/${address}${type == 'txblock' ? '?tab=Changes' : ''}`;
}

export function shortenString(str: string) {
	if (str.length > 10) {
		const start = str.slice(0, 6);
		const end = str.slice(-4);
		return `${start}...${end}`;
	}
	return str;
}

export function shortenSuiNS(str: string) {
	if (str.length > 10) {
		const start = str.slice(0, 8);
		return `${start}...`;
	}
	return str;
}

export function shortenHex(hex: string) {
	if (hex.startsWith('0x')) {
		return shortenString(hex);
	}
	return hex;
}

export function shortenIfEmail(email: string): string {
	if (email.includes('@')) {
		const [localPart] = email.split('@');
		return localPart;
	} else {
		return email;
	}
}

export function shortenUsername(username: string) {
	if (username.includes('@')) {
		username = shortenIfEmail(username);
	}
	username = shortenHex(username);
	return shortenSuiNS(username);
}

export function isValidHexSuiAddress(address: string) {
	return /^0x[a-fA-F0-9]{64}$/.test(address);
}

export function isValidSuinsName(name: string) {
	return /^[a-zA-Z0-9.]+\.sui$/.test(name);
}

export function isValidB64SuiAddress(str: string) {
	try {
		const decoded = B64ToHex(str);
		return isValidHexSuiAddress(decoded);
	} catch {
		return false;
	}
}

export function B64ToHex(b64: string): string {
	const binaryStr = atob(b64);
	const hex = Array.from(binaryStr)
		.map((char) => char.charCodeAt(0).toString(16).padStart(2, '0'))
		.join('');
	return '0x' + hex;
}

export function HexToB64(hex: string): string {
	const binaryStr =
		hex
			.slice(2) // Remove "0x" prefix
			.match(/.{1,2}/g) // Split into byte-sized chunks
			?.map((byte) => String.fromCharCode(parseInt(byte, 16))) // Convert hex to char
			.join('') || '';
	return btoa(binaryStr);
}

export function UQ32ToFloat(input: { pos0: string }) {
	const pos0Value = BigInt(input.pos0);
	return Number(pos0Value) / 4294967296;
}

export function fromBaseUnits(amount: number, decimals: number): number {
	return amount / Math.pow(10, decimals);
}

export function mistToSui(mist: number): number {
	return mist / 1_000_000_000;
}

export function suiToMist(amount: number): number {
	return amount * 1_000_000_000;
}

export function toBaseUnits(amount: number, decimals: number): number {
	return Math.round(amount * Math.pow(10, decimals));
}
